export default __webpack_public_path__ + "static/media/left-green-icon.c8b1af4e.svg";